import { memo } from 'react';
import Button from '@mui/material/Button';

export default memo(Button);
